<template>
     <!-- INICIO FILTRO HISTÓRICO -->
    <form class="row wallet__filter">
        <div class="col-12 col-md-5 col-lg-5">
            <div class="row no-gutters wallet__filter--date">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="inicio">Início</label>
                        <i class="ico-calendar"></i>
                        <!-- PLUGIN DE CALENDARIO COM VUEJS -->
                        <datetime 
                            v-model="filtro.dataIni" 
                            placeholder="__/__/____" 
                            class="theme-iouu" 
                            input-class="form-control form-control-lg" 
                            type="text" 
                            format="dd/MM/yyyy">
                        </datetime>
                        <!-- :::::::::::::::::::: -->
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="fim">Fim</label>
                        <i class="ico-calendar"></i>
                        <!-- PLUGIN DE CALENDARIO COM VUEJS -->
                        <datetime 
                            v-model="filtro.dataFim" 
                            placeholder="__/__/____" 
                            class="theme-iouu" 
                            input-class="form-control form-control-lg" 
                            type="text" 
                            format="dd/MM/yyyy">
                        </datetime>
                        <!-- ::::::::::::::::::: -->
                    </div>
                </div>
            </div>
        </div>
        
        <div class="col-12 col-md-3 col-lg-3 wallet__filter--search">
            <label for="busca"></label>
            <div class="input-group">
                <div class="input-group-append">
                    <button class="btn btn-secondary" id="search" type="button" @click="enviarFiltro">Procurar</button>
                </div>
            </div>
        </div>
    </form>
    <!-- FINAL FILTRO HISTÓRICO -->
</template>

<script>
    export default {
        data() {
            return {
                filtro: {
                    dataIni: '',
                    dataFim: '',
                }
            }
        },
        methods: {
            formatarData(data) {

                if(!data.includes('/') ) return ''

                data = new Date(data).toLocaleString('pt-BR', { timeZone: 'UTC' }).split(" ")[0]

                return data.replace(/[/]/g, '-')
            },
            enviarFiltro() {

                this.filtro.dataIni = this.formatarData(this.filtro.dataIni)

                this.filtro.dataFim = this.formatarData(this.filtro.dataFim)

                this.$emit('filtrar', this.filtro);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Wallet/WalletExtratoFiltro.vue